import React, { Component } from "react"
import { translate } from "react-translate"
import { Dropdown } from "semantic-ui-react"
import "./FiltreStatut.css"
import _ from "lodash"

const optionsStatuts = [
  { key: "accepté", text: "value_dropdown_accepté", value: 1 },
  { key: "finalisé", text: "value_dropdown_finalisé", value: 2 },
  { key: "brouillon", text: "value_dropdown_brouillon", value: 0 },
  { key: "abandonné", text: "value_dropdown_abandonné", value: 3 }
]

class FiltreStatut extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggle: true,
      value: []
    }
  }

  componentWillMount() {
    let { t } = this.props
    var optionsStatutsCopy = _.clone(optionsStatuts)
    optionsStatutsCopy = _.map(optionsStatutsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      optionsStatuts: optionsStatutsCopy
    })
  }

  render() {
    let { t } = this.props

    return (
      <Dropdown
        id="statutFiltre"
        placeholder={t("placeholder_dropdown_statut")}
        fluid
        multiple
        selection
        onChange={(e, val) => {
          this.props.handleDropdownChange(e, val)
        }}
        options={this.state.optionsStatuts || []}
      />
    )
  }
}

export default translate("ProEnteteStatusFilter")(FiltreStatut)



// WEBPACK FOOTER //
// ./src/components/Pro/Entete/FiltreStatut.js